import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Button, Text, Heading, Link } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import TwoColumns from '../../components/shared/TwoColumns';
import HeroWithVideo from '../../components/shared/HeroWithVideo';
import InfoSection from '../../components/shared/InfoSection';

const INFO_ITEMS = [
  {
    image: (
      <StaticImage
        style={{ maxWidth: 150 }}
        src="../../images/2x-house-icon.png"
        alt="Icon 2x house"
      />
    ),
    title: 'Faster',
    description:
      'Assess twice as many properties by saving time on commercial or residential sites',
  },
  {
    image: (
      <StaticImage
        style={{ maxWidth: 100 }}
        src="../../images/magnifier-scale-icon.png"
        alt="Icon magnifier and scale"
      />
    ),
    title: 'More Accurate',
    description:
      'Create defendable property valuations with measurements proven to be more accurate than aerial or measuring tape',
  },
  {
    image: (
      <StaticImage
        style={{ maxWidth: 100 }}
        src="../../images/monitor-with-pencil-icon.png"
        alt="Icon monitor with pencil"
      />
    ),

    title: 'Less Work',
    description:
      'Say goodbye to manual measurements - our output will provide you with a complete sketch perfect for tax assessment',
  },
];

const TaxAssessors = () => (
  <Layout isNavInitiallyTransparent={false} title="Tax Assessors">
    <HeroWithVideo
      heroContent={
        <Box color="white" mt="10">
          <Heading fontSize={['3xl', '3xl', '4xl', '4xl']}>
            Accurate measurements. <br />
            Gross living area. <br />
            2x faster.
          </Heading>
          <Text my="7" fontSize="lg">
            The only app with to-the-inch measurements from a few photos
          </Text>
          <Link
            href="https://calendly.com/hover-sdr/hover-tax-assessors"
            target="_blank"
          >
            <Button size="lg">Schedule a Call</Button>
          </Link>
        </Box>
      }
      videoTitle="HOVER - For Tax Assessors Video"
      videoUrl="https://fast.wistia.net/embed/iframe/nkkgaj5syx?videoFoam=true"
    />

    <InfoSection
      sectionTitle="Get data quickly and easily to make the most of your field time"
      numColumns={3}
      infoItems={INFO_ITEMS}
    />

    <TwoColumns
      col1={
        <Box>
          <Heading mb="10">The most comprehensive property data</Heading>
          <Text>
            HOVER transforms smartphone photos of any weathertight property into
            a complete property data set – including gross living area – to
            accurately and efficiently assess value.
          </Text>
        </Box>
      }
      col2={
        <StaticImage
          src="../../images/house-graphic.webp"
          alt="house graphic"
        />
      }
    />

    <TwoColumns
      col1={
        <StaticImage
          src="../../images/app_ui_TLA_interface@1x.webp"
          alt="house graphic"
        />
      }
      col2={
        <Box>
          <Heading mb="10">What’s in it for you?</Heading>
          <Box mb="5">
            <Text fontSize="xl" fontWeight="bold" mb="2">
              Auto-generated GLA Data
            </Text>
            <Text>
              Receive the gross living area measurements without interior
              photos. Eight exterior photos are all that’s needed to inspect any
              property.
            </Text>
          </Box>
          <Box mb="5">
            <Text fontSize="xl" fontWeight="bold" mb="2">
              The Most Defendable, Accurate Property Valuations
            </Text>
            <Text>
              With the most accurate measurements on the market, leverage
              HOVER’s property data to generate the fairest, most equitable
              property valuations possible.
            </Text>
          </Box>
        </Box>
      }
    />

    <TwoColumns
      reverseOrderInMobile
      col1={
        <Box mt="10">
          <Heading>Connect with us</Heading>
          <Text my="10" fontSize="xl">
            Learn more about how HOVER can help you assess more efficiently and
            accurately than ever before.
          </Text>
          <Link
            href="https://calendly.com/hover-sdr/hover-tax-assessors"
            target="_blank"
          >
            <Button size="lg">Schedule a Call</Button>
          </Link>
        </Box>
      }
      col2={
        <Box textAlign="center">
          <StaticImage
            style={{ maxWidth: 300 }}
            src="../../images/connect-app-screen-hi-res.webp"
            alt="house graphic"
          />
        </Box>
      }
    />
  </Layout>
);

export default TaxAssessors;
